import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const NotFoundMessage = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: 0,
  right: 0,
  transform: 'translateY(-50%)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 1, 0, 1)
  }
}));
